import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import DashboardLineGraph from './ComponentFragments/DashboardLineGraph';

export default class TeamPerformanceSummary extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            teamData: [],
            yearData: [],
            fromWeekData: [],
            unitData: [],
            toWeekData: [],
            selectedYear: 0,
            selectedFromWeek: 0,
            selectedToWeek: 0,
            selectedUnit: 0,
            selectedUnitName: '',
            teamGraphData: {
                labels: [],
                currYTDSales: [],
                prevYTDSales: []
            },
            tableHidden: true
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleFromSelectChange = this.handleFromSelectChange.bind(this);
        this.handleToSelectChange = this.handleToSelectChange.bind(this);
        this.getTeamPerformance = this.getTeamPerformance.bind(this);
        this.handleUnitSelectChange = this.handleUnitSelectChange.bind(this);
    }

    async loadWeeksForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getweeksforyear?yearId=' + year, 200);
        let fromWeeksData = [];
        let toWeeksData = [];
        result.data.forEach((week) => fromWeeksData.push({ checked: false, value: week.value, text: week.label }));
        result.data.forEach((week) => toWeeksData.push({ checked: false, value: week.value, text: week.label }));

        fromWeeksData[0].checked = true;
        toWeeksData[0].checked = true;
        this.setState({
            fromWeekData: fromWeeksData,
            toWeekData: toWeeksData,
            selectedFromWeek: fromWeeksData[0].value,
            selectedToWeek: toWeeksData[0].value
        })

        this.props.loaderOff();
    }

    handleUnitSelectChange(selected) {
        let unitName = "";
        for (var i = 0; i < this.state.unitData.length; i++) {
            if (this.state.unitData[i].value == selected[0]) {
                unitName = this.state.unitData[i].text
            }
        }
        this.setState({
            selectedUnit: selected[0],
            selectedUnitName: unitName
        });
    }

    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadWeeksForYear(selected[0])
    }

    handleFromSelectChange(selected) {
        this.setState({
            selectedFromWeek: selected[0]
        });
    }

    handleToSelectChange(selected) {
        this.setState({
            selectedToWeek: selected[0]
        });
    }

    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let yearsData = [];
        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let unitsData = [];
        if (TMAUser.data.statusCode1 == 'T') {
            let unitResponse = await dl.Get('/teamleader/getunitslist', 200)
            let allUnits = { checked: true, value: 0, text: 'All Team Units' }
            unitsData.push(allUnits);
            unitResponse.data.data.forEach((unit) => unitsData.push({ checked: false, value: unit.unitId, text: unit.unitName }));
            //unitsData[0].checked = true;
        }

        let teamGraphData = {
            labels: [],
            currYTDSales: [],
            prevYTDSales: []
        }
        let graphResponse;
        if (TMAUser.data.statusCode1 == 'T') {
            graphResponse = await dl.Post('/common/GetGraphData', 1)
        } else {
            graphResponse = await dl.Post('/common/GetGraphData', 2)
        }

        graphResponse.data.forEach((entry) => {
            teamGraphData.labels.push(entry.month);
            teamGraphData.currYTDSales.push(entry.currYr);
            teamGraphData.prevYTDSales.push(entry.prevYr);
        })

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            unitData: unitsData,
            teamGraphData: teamGraphData
        })
        this.props.loaderOff();
    }

    async getTeamPerformance() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let unitId = TMAUser.data.statusCode1 == "T" ? this.state.selectedUnit : TMAUser.data.unitId
        await dl.Get('/teamleader/GetTeamPerformanceSummary?fromWeek=' + this.state.selectedFromWeek + '&toWeek=' + this.state.selectedToWeek + '&unitId=' + unitId, 200).then((response) => {
            let demRecs = [];
            let rec;
            
            response.data.map((perfRec) => {
                let currVal = 0
                let prevVal = 0;
                let calcCurrVal = 0;
                let calcPrevVal = 0;
                switch (perfRec.description) {
                    case unitId == 0 ? "Team Sales" : "Unit Sales":
                    case "Ave Sales Per Active SF":
                    case "Productivity":
                        currVal = this.formatter.formatCurrency(perfRec.currentValue);
                        calcCurrVal = perfRec.currentValue;
                        if (perfRec.previousValue === 'NaN' || perfRec.previousValue == NaN || perfRec.previousValue == undefined) {
                            prevVal = 0;
                            calcPrevVal = 0;
                        } else {
                            prevVal = this.formatter.formatCurrency(perfRec.previousValue);
                            calcPrevVal = perfRec.previousValue
                        }
                        break;
                    default:
                        currVal = perfRec.currentValue;
                        calcCurrVal = perfRec.currentValue
                        if (perfRec.previousValue === 'NaN' || perfRec.previousValue == NaN || perfRec.previousValue == undefined) {
                            prevVal = 0;
                            calcPrevVal = 0;
                        } else {
                            prevVal = perfRec.previousValue;
                            calcPrevVal = perfRec.previousValue;
                        }
                }
                rec = {
                    description: [<span style={{ fontWeight: 'bold' }}>{perfRec.description}</span>],
                    currentValue: currVal,
                    previousValue: prevVal,
                    percentage: perfRec.percentage.toFixed(0)//(calcCurrVal - calcPrevVal / (calcPrevVal == 0 ? 1 : calcPrevVal)) * 100 //this.formatter.formatCurrency(perfRec.percentage)
                }
                demRecs.push(rec);
            });

            let tableData = {
                columns: [{
                    label: 'Description',
                    field: 'description',
                    sort: 'asc'
                },
                {
                    label: 'Current Value',
                    field: 'currentValue',
                    sort: 'asc'
                },
                {
                    label: 'Previous Value',
                    field: 'previousValue',
                    sort: 'asc'
                }, {
                    label: '% Change',
                    field: 'percentage',
                    sort: 'asc'
                }],
                rows: demRecs
            }
            this.setState({
                teamData: tableData,
                tableHidden: false
            });
            this.props.loaderOff();
        })

    }

    render() {
        let TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        let statusType = TMAUser.data.statusCode1;
        let subHeaderText = "(Click Go to load team/unit summary report for selected weeks. Select All Team Units to run for Team.)";
        if (statusType == "M") {
            subHeaderText = "(Click Go to load unit summary report for selected weeks.)"
        }
        return (
            <div>
                <Header headerText='Performance Summary'
                    subHeaderText={subHeaderText}
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                <MDBRow>
                    <MDBCol md="6">
                        <MDBContainer>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Year..."
                                        options={this.state.yearData}
                                        selected="Filter"
                                        getValue={this.handleYearSelectChange}
                                        required
                                    />
                                </MDBCol>

                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="From Week..."
                                        options={this.state.fromWeekData}
                                        selected="Filter"
                                        getValue={this.handleFromSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="To Week..."
                                        options={this.state.toWeekData}
                                        selected="Filter"
                                        getValue={this.handleToSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            {statusType == "T" ? <MDBRow className="mt-3">
                                <MDBCol>
                                    <MDBSelect label="Unit..."
                                        options={this.state.unitData}
                                        selected="Filter"
                                        getValue={this.handleUnitSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow> : <div></div>}
                            <MDBRow>
                                <MDBCol>
                                    <MDBBtn onClick={this.getTeamPerformance}>Go</MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                    </MDBCol>

                    <MDBCol md="6">
                        <MDBContainer>
                            <DashboardLineGraph chartName={statusType == "T" ? "Team Sales Performance" : "Unit Sales Performance"} graphData={this.state.teamGraphData} />
                        </MDBContainer>
                    </MDBCol>
                </MDBRow>

                <br />

                <div hidden={this.state.tableHidden}>
                    <hr />
                    <MDBContainer>
                        <MDBRow>
                            {this.state.selectedUnit == 0 && statusType == "T" ?
                                <div style={{ fontWeight: "bold" }}>Summarized Team Results<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</div> :
                                <div style={{ fontWeight: "bold" }}>Summarized Unit Results for {this.state.selectedUnitName}<br />Weeks {this.state.selectedFromWeek} to {this.state.selectedToWeek}</div>}
                        </MDBRow>
                        <MDBRow>
                            <div>(Showing results for selected weeks for current year vs the same weeks for previous year)</div>
                            </MDBRow>
                        
                    </MDBContainer>
                    <div style={{paddingBottom:"15px"}}></div>
                    <MDBContainer>
                    <MDBDataTable
                        responsive
                        striped
                        bordered
                        hover
                        data={this.state.teamData}
                        paging={false}
                        autoWidth
                        searching={false}
                        />;
</MDBContainer>        
                        </div>
                    </MDBCardBody>
                    </MDBCard>
            </div>
        );
    }


}
